import SmallShareButtons from './SmallShareButtons';

export default SmallShareButtons;
